//import the Polymer library
import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";
import { afterNextRender } from "@polymer/polymer/lib/utils/render-status.js";

import "../../../components/desktop/webinar/SearchWebinarHeader/SearchWebinarHeader";
import "../../../components/desktop/webinar/WebinarMenuOption/WebinarMenuOption";
import "../../../components/desktop/webinar/FilterScientific/FilterScientific";
import "../../../components/desktop/webinar/FilterWebinarStatus/FilterWebinarStatus";
import "../../../components/desktop/webinar/FilterWebinarType/FilterWebinarType";
import "../../../components/desktop/webinar/WebinarLandingList/WebinarLandingList";
import Alodokter from "../../../utils/Alodokter";
import WebinarAnalytics from "../../../analytics/WebinarAnalytics";

class WebinarPage extends PolymerElement {
    static get template() {
        return html `
        <style>
            .container {
                margin: 0 auto;
                padding: 26px 2px 150px;
                display: flex;
                justify-content: space-between;
                gap: 20px;
            }
            .main-container {
                width: 660px;
            }
            .side-container {
                width: 320px;
            }
        </style>
        <div class="container">
            <!-- SIDE CONTAINER -->
            <div class="side-container">
                <webinar-menu-option></webinar-menu-option>
                <filter-scientific user-uid={{userUid}}></filter-scientific>
                <filter-webinar-type></filter-webinar-type>
                <filter-webinar-tatus></filter-webinar-tatus>
                
            </div>
            <!-- SIDE CONTAINER -->

            <!-- MAIN CONTAINER -->
            <div class="main-container">
                <webinar-landing-list webinar-list={{constructWebinarList(webinarList)}} user-uid={{userUid}} is-login={{isLogin}}></webinar-landing-list>
            </div>
            <!-- MAIN CONTAINER -->
        </div>
        `;
    }

    static get properties() {
        return {
            webinarList: {
                type: Array
            },
            userUid: {
                type: String
            },
            isLogin: {
                type: Number
            },
            disclaimerTitle: {
                type: String
            },
            disclaimerBody: {
                type: String
            }
        }
    }

    ready() {
        super.ready();
        afterNextRender(this, function() {
            // Tracker Payment final status is Loaded
            const additionalTracker = this.userUid && this.isLogin ? `user_uid: ${this.userUid} | ` : "";
            const sourceUrl = window.location.href;
            const eventLabel = `${additionalTracker}device_category: desktop | source_url: ${sourceUrl}`
            Alodokter.sendEventGA("webinar landing page", "webinar_landing_viewed", eventLabel);
        });
    }

    constructWebinarList(webinarList) {
        return webinarList.map((webinar, index) => ({...webinar, index: index}));
    }
}

customElements.define("webinar-page", WebinarPage);